// Visualizações com Container de Checkout

const publicRoutes = [
  {
    path: '/sale-checkout/:id',
    name: 'Checkout',
    component: () => import('@/view/pages/public/checkout/Overview.vue'),
  },
  {
    path: '/sale-checkout/:id/detail',
    name: 'CheckoutDetail',
    component: () => import('@/view/pages/public/checkout/Details.vue'),
    props: true,
  },
  {
    path: '/checkout',
    component: () => import('@/view/Layouts/AuthContainer/AuthContainer.vue'),
    // AuthContainer usa esse meta para decidir o layout (logo, slides, posição).
    meta: {
      publicLayout: true,
    },
    children: [
      {
        name: 'Criação de Deposito Público',
        path: '/checkout/:document',
        component: () => import('@/view/pages/public/PublicDeposit/PublicDeposit.vue'),
      },
    ],
  },
  {
    path: '/pagador',
    component: () => import('@/view/Layouts/AuthContainer/AuthContainer.vue'),
    // AuthContainer usa esse meta para decidir o layout (logo, slides, posição).
    meta: {
      publicLayout: true,
    },
    children: [
      {
        path: '',
        name: 'Área do Pagador',
        props: true,
        component: () => import('@/view/pages/public/Payments/Public.vue'),
      },
      {
        path: '/pagador/boleto/:id',
        name: 'Visualização de boleto publico',
        props: true,
        component: () => import('@/view/pages/shared/printables/invoices/BoletoPublic.vue'),
      },
    ],
  },
  {
    path: '/pagador/cobrancas',
    name: 'Cobranças do Pagador',
    component: () => import('@/view/pages/public/Payments/PublicPayerDebts.vue'),
  },
  {
    path: '/baixar-app',
    name: 'BaixarApp',
    component: () => import('@/view/pages/public/BaixarApp/BaixarApp.vue'),
  },
  {
    path: '/qrcode',
    name: 'QrCode',
    component: () => import('@/view/pages/public/QrCode/QrCode.vue'),
    meta: { devOnly: true },
  },
]

export default publicRoutes
